import React from "react";

const Global = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            fill="#4E525F"
            fillRule="evenodd"
            d="M19.134 2.486a1.56 1.56 0 0 0-.545-.03 15.55 15.55 0 0 0-1.085-.004 1.56 1.56 0 0 0-.462.022 15.554 15.554 0 0 0 0 31.052c.151.03.307.038.462.022.165.005.33.008.496.008a1.556 1.556 0 0 0 .234-3.094 24.887 24.887 0 0 1-2.554-6.24H18a1.556 1.556 0 1 0 0-3.11h-2.916a24.9 24.9 0 0 1 0-6.223h5.848c.12 1.031.18 2.07.18 3.111a1.556 1.556 0 1 0 3.11 0c0-1.038-.052-2.076-.16-3.111h5.987c.261 1.01.396 2.056.396 3.111a1.556 1.556 0 1 0 3.11 0 15.555 15.555 0 0 0-14.42-15.514Zm9.643 9.292a12.445 12.445 0 0 0-7.096-5.665 27.302 27.302 0 0 1 1.886 5.665h5.21Zm-8.402 0a23.882 23.882 0 0 0-2.315-5.934 24.884 24.884 0 0 0-2.38 5.934h4.695Zm-7.897 0a28.005 28.005 0 0 1 1.967-5.704 12.445 12.445 0 0 0-7.222 5.704h5.255Zm-6.527 3.11a12.456 12.456 0 0 0 0 6.223h6a28.008 28.008 0 0 1 0-6.222h-6Zm6.527 9.334H7.223a12.444 12.444 0 0 0 7.222 5.704 28.003 28.003 0 0 1-1.967-5.704Zm14.855-4.666c.86 0 1.556.696 1.556 1.555v7.134l2.011-2.012a1.556 1.556 0 1 1 2.2 2.2L28.433 33.1a1.556 1.556 0 0 1-2.2 0l-4.666-4.667a1.556 1.556 0 0 1 2.2-2.2l2.01 2.012V21.11c0-.859.697-1.555 1.556-1.555Z"
            clipRule="evenodd"
        />
    </svg>
);

export default Global;